<template>
  <div :class="openerClass" :title="$i18n.t('saved_searches')">
    <div @click="onClick">
      <span v-if="bareLink"><i class="material-icons md-18 icon-align">save</i>{{ $i18n.t('saved_searches') }}</span>
      <span v-else class="material-icons md-18">save</span>
    </div>
    <modal
      :id="modalIdSave"
      :title="$i18n.t('saved_searches')"
      :show-header="true"
      class="details-modal modal-md"
    >
      <saved-filter @load-list-filter="loadFilter"/>
    </modal>
  </div>
</template>

<script>
import Modal from '../modal/Modal.vue'
import SavedFilter from './SavedFilter.vue'
import ModalOpener from '../modal/Opener.vue'
import { cleanValue } from '../templated-list/helpers'
import localStore from '../../utils/mixin-local-store'
import { mapActions } from 'vuex'
import EventBus from '../../utils/event-bus'
import { PANEL_TYPES } from '../layout-manager/gui-editor/options/schema'

export default {
  name: 'SavedFilterOpener',
  mixins: [localStore],
  components: {
    ModalOpener,
    SavedFilter,
    Modal,
  },
  props: {
    bareLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filterColumns() {
      return this.$get('filterColumns')
    },
    id() {
      return this.$get('id')
    },
    isTemplatedListControl() {
      return this.$get('componentType') === PANEL_TYPES.TEMPLATED_LIST
    },
    modalIdSave() {
      return `list-modal-save-${this.panelUid}`
    },
    openerClass() {
      return this.bareLink ? '' : 'el-button is-plain el-button--default el-button--small btn is-plain'
    },
    panelId() {
      return this.$get('panelId')
    },
    panelUid() {
      return this.$get('panelUid')
    },
  },
  methods: {
    ...mapActions(['hideModal', 'showModal']),
    loadFilter({ params }) {
      if (this.isTemplatedListControl) {
        this.localStore.removeItemValue('filter')
        this.$dispatch('clearFilter')
        Object.keys(params).forEach((key) => {
          const savedValue = cleanValue(params[key])
          if (savedValue) {
            this.$dispatch('updateFilterColumnValue', { data: key, value: savedValue })
          }
        })
        this.$dispatch('setSearchTrigger', { searchTrigger: 'saved-filter' })
      } else {
        //@TODO new-listtel kiegyenesiteni
        this.$dispatch('setSearchParams', { params })
        EventBus.$emit(`apply-filter-${this.id}`, {
          id: this.id,
          type: 'saved-filter',
        })
        this.hideModal(this.modalIdSave)
      }
    },
    onClick() {
      this.showModal({ id: this.modalIdSave })
    },
  },
}
</script>